import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { NavLink, useLocation, Route, Routes, Navigate } from 'react-router-dom';
import '../assets/AdminPanel.css';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../redux/slice/authSlice';
import { routes } from '../userRoutes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark, faRightFromBracket, faUser } from '@fortawesome/free-solid-svg-icons';
import Logo from '../assets/logo.png';
import Cookies from 'js-cookie';
import SessionExpiryWarning from '../components/SessionExpiryWarning';
import Footer from '../components/Footer';

const UserLayout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const location = useLocation();
    const dispatch = useDispatch();
    const tokenRefresh = Cookies.get('tokenRefresh')
    const { user } = useSelector(state => state.auth);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 1200) {
                setSidebarOpen(false);
                setIsMobile(true);
            } else {
                setSidebarOpen(true);
                setIsMobile(false);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleLogout = () => {
        dispatch(logout({ refresh: tokenRefresh }))
        // Cookies.remove('tokenRefresh'); // Διαγραφή cookie
        // Cookies.remove('tokenAccess'); // Διαγραφή cookie
        // localStorage.clear();
    };

    const toggleSidebar = () => {
        if (isMobile) {
            setSidebarOpen(!sidebarOpen);
        }
    };

    const getRoutes = (routes) => {
        return routes.map((prop, key) => {
            if (prop.layout === "/user") {
                return (
                    <Route path={prop?.path} element={prop?.component} key={key} exact />
                );
            }
            return null;
        });
    };

    const activeRoute = (routeName) => {
        return location.pathname === routeName ? 'active' : '';
    };

    const handleShowLogoutModal = () => setShowLogoutModal(true);
    const handleCloseLogoutModal = () => setShowLogoutModal(false);

    const getTitle = () => {
        const route = routes.find(route => route.path === location.pathname.replace('/user', ''));
        return route ? route.name : 'Αρχική Σελίδα';
    };

    return (
        <Container fluid className="admin-container">

            <Row className='admin-navbar'>
                <Col className='admin-col'>
                    {isMobile && (
                        <Button className="menu-btn" onClick={toggleSidebar} variant="dark">
                            <FontAwesomeIcon icon={sidebarOpen ? faXmark : faBars} />
                        </Button>
                    )}
                </Col>
                <Col className='admin-col' xs={5} style={{ display: 'flex', justifyContent: 'center' }}>
                    <h5 style={{ fontSize: '1.2rem' }}>{getTitle()}</h5>
                </Col>
                <Col className='admin-col' style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                    {(user?.first_name && user?.last_name) && <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center' }}>
                        <OverlayTrigger placement="bottom" overlay={<Tooltip className="in" id="tooltip-top">
                            <strong>{user?.first_name}{' '}{user?.last_name}</strong>
                        </Tooltip>
                        }>
                            <div>

                                <FontAwesomeIcon icon={faUser} size='lg' style={{ marginRight: '10px', width: '20px' }} />
                                <strong>{user?.last_name}</strong>
                            </div>
                        </OverlayTrigger>
                    </div>}
                </Col>
            </Row>

            <Row className='row-admin'>
                <Col xs={sidebarOpen ? 12 : 0} sm={sidebarOpen ? 12 : 0} md={sidebarOpen ? 12 : 0} lg={sidebarOpen ? 3 : 0} xl={2} xxl={2} className="sidebar" style={{ transform: sidebarOpen ? 'translateX(-0)' : 'translateX(-110%)' }}>
                    <div className="sidebar-content">
                        <div>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', borderBottom: '1px solid #e0e0e0', paddingBottom: '10px', marginTop: '10px', marginBottom: '20px' }}>
                                <img src={Logo} alt="react-logo" style={{ width: '40px', marginRight: '10px' }} />
                                <strong>Λ.Α.Φ. Αλεξανδρούπολης</strong>
                            </div>
                            <ul className="sidebar-menu">
                                {routes.map((route, index) => (
                                    <li className={`sidebar-menu-item ${activeRoute(route.path)}`} key={index}>
                                        <NavLink
                                            to={route?.layout + route?.path}
                                            className="nav-link"
                                            onClick={toggleSidebar}
                                        >
                                            <FontAwesomeIcon icon={route?.icon} size='sm' style={{ marginRight: '10px', width: '20px' }} />{route?.name}
                                        </NavLink>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div onClick={handleShowLogoutModal} className={`sidebar-menu-item`}>
                            <FontAwesomeIcon icon={faRightFromBracket} size='sm' style={{ marginRight: '10px', width: '20px' }} />
                            Αποσύνδεση
                        </div>
                    </div>
                </Col>

                <Col xs={sidebarOpen ? 0 : 12} sm={sidebarOpen ? 0 : 12} md={sidebarOpen ? 0 : 12} lg={sidebarOpen ? 9 : 12} xl={8} xxl={10} className="main-content" style={{ marginLeft: sidebarOpen ? '280px' : '0px' }}>
                    <Routes>
                        {getRoutes(routes)}
                        <Route path="/" element={<Navigate to="/user/calendar" replace />} />
                        <Route path="*" element={<Navigate to="/user/calendar" replace />} />
                    </Routes>
                </Col>
            </Row>
            {/* Modal Αποσύνδεσης */}
            <Modal show={showLogoutModal} onHide={handleCloseLogoutModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Επιβεβαίωση Αποσύνδεσης</Modal.Title>
                </Modal.Header>
                <Modal.Body>Είστε σίγουροι ότι θέλετε να αποσυνδεθείτε;</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseLogoutModal}>
                        <strong>Ακύρωση</strong>
                    </Button>
                    <Button variant="primary" onClick={() => { handleLogout(); handleCloseLogoutModal(); }}>
                        <strong>Αποσύνδεση</strong>
                    </Button>
                </Modal.Footer>
            </Modal>
            <SessionExpiryWarning />
            <Footer />
        </Container>
    );
};

export default UserLayout;
